import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div
        className="min-h-screen bg-[#0A0F1C] text-slate-400 flex items-center justify-center"
        data-testid="auth-checking"
      >
        Checking session…
      </div>
    );
  }
  if (user === null) return <Navigate to="/admin/login" replace />;
  if (adminOnly && user.role !== "admin")
    return <Navigate to="/admin/leads" replace />;
  return children;
}
